import React from 'react';
import { Helmet } from 'react-helmet';
import '../assets/styles/LegalPage.css';

interface LegalPageProps {
  title: string;
  lastUpdated?: string;
  content: React.ReactNode;
}

const LegalPage: React.FC<LegalPageProps> = ({ title, lastUpdated, content }) => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>{title} | Translate Stocks</title>
        <meta 
          name="description" 
          content={`${title} for Translate Stocks and Price on Rails trading platform.`}
        />
      </Helmet>

      <div className="container">
        <div className="legal-page-wrapper">
          <div className="legal-header">
            <h1>{title}</h1>
            {lastUpdated && <p className="last-updated">Last updated: {lastUpdated}</p>}
          </div>
          
          <div className="legal-content">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;